import './App.css';
import AppRouter from './routers/AppRouter';
import "./CSS/common.css"

function App() {
 
  return (
    <div className="App">
      <AppRouter />

    </div>
  );
}

export default App;
